export default function scrollTabs() {
    $(function(){$(".scroll-tab").click(function(){
    	$( ".coaches-info" ).addClass( "active" );
    	$("html,body").animate({scrollTop:$(".top").offset().top},"1000");
    	return false
    	}
    )})
}
